export interface Lead {
  id: number;
  businessID: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  form: string;
  eventTime: string; // ISO Date
  raw: object;
}

export const exampleLead: Lead = {
  id: 1,
  businessID: 1,
  firstName: 'John',
  lastName: 'Doe',
  email: 'johndoe@gmail.com',
  phone: '13145555555',
  form: 'Test Campaign 1/2 Off',
  eventTime: '2020-08-03T19:14:13.172Z',
  raw: {
    firstName: 'John',
    lastName: 'Doe',
  },
};
